var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('Navbar'),_c('LeftDrawer'),_c('v-main',{staticStyle:{"background":"#FAFAFA"}},[_c('v-row',[_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }